import service from '@/utils/server';

const modName = '/bd/trackReject/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};
//详情
export const detailInfo = data => {
  return service({
    url: modName + 'detail/' + data.id,
    method: 'post',
    data
  });
};
//批量删除
export const deleteBatch = data => {
  return service({
    url: modName + 'batchDelete',
    method: 'post',
    data
  });
};
//导出
export const exportData = data => {
  let config = {
    timeout: 500000,
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};
//运输商拒收导入
export const carrierRejectImport = data => {
  let config = {
    timeout: 500000,
    headers: {
      "Content-Type": "multipart/form-data"
    },
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'trackCarrierRejectImport',
    method: 'post',
    data
  });
};
//提交审批确认
export const submitApproval = data => {
  return service({
    url: modName + 'submitApprove',
    method: 'post',
    data
  });
};

//加急拒收报告
export const urgentRejectReport = data => {
  return service({
    url: modName + 'urgentRejectReport',
    method: 'post',
    data
  });
};
//仓库收货上传
export const warehouseReceiptUpload = data => {
  let config = {
    timeout: 500000,
    headers: {
      "Content-Type": "multipart/form-data"
    },
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'trackWhRejectLocImport',
    method: 'post',
    data
  });
};
//模板下载
export const downLoadTemplate = data => {
  let config = {
    timeout: 500000,
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'template/' + data.templateName,
    method: 'post',
    data
  });
};
//拒收报告导出
export const exportReport = data => {
  let config = {
    timeout: 500000,
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'exportReport',
    method: 'post',
    data
  });
};

/**
 * 待收货上传导出
 * @param data
 * @returns {*}
 */
export const toBeReceivedExportData = data => {
  let config = {
    timeout: 500000,
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'toBeReceivedExport',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/reject/rejectInfo/api/index.js